<template>
  <div class="step3-wrapper">
    <div class="header">
      <label class="title">选裂变物料</label>
      <p class="tip">选择合适的内容，单击即可获取裂变海报。<br />将裂变海报推广出去即可利用课程宝服务号实现裂变<br />涨粉，推广前可将海报发给课程宝客服检查确认<br />【★所有内容均为正版，请放心使用】</p>
    </div>

    <Menu :items="categories" @on-change-menu="onChangeMenu" />

    <div class="course-list">
      <div class="course-items">
        <Course v-for="(course, index) in courses" v-if="index % 3 === 0" :data="course" @on-select-course="onSelectCourse" />
      </div>
      <div class="course-items">
        <Course v-for="(course, index) in courses" v-if="index % 3 === 1" :data="course" @on-select-course="onSelectCourse" />
      </div>
      <div class="course-items">
        <Course v-for="(course, index) in courses" v-if="index % 3 === 2" :data="course" @on-select-course="onSelectCourse" />
      </div>
    </div>

    <ShareModal :active="isShareModalActive" :channel="channel" :classId="classId" @close="close" />
  </div>
</template>

<script>
import Notes from '@/engine/Notes'

import Course from '@/components/Course.vue'
import Menu from '@/components/Menu.vue'
import ShareModal from '@/components/ShareModal.vue'

const state = {
  categoryCourses: {}
}

const fetchCourses = (vw, categoryId) => {
  const params = {}
  if (categoryId) {
    params.categoryId = categoryId
  }
  Notes.fetchCourses(params).then(({ classes }) => {
    vw.courses = classes
    state.categoryCourses[categoryId || 'all'] = classes
  })
}

export default {
  name: 'step3',
  components: {
    Course,
    Menu,
    ShareModal,
  },
  data () {
    return {
      courses: [],
      categories: [],
      channel: '',
      classId: '',
      isShareModalActive: false,
    }
  },
  mounted () {
    Notes.fetchCategories().then(({ categories }) => {
      this.categories = [{
        name: '全部',
        id: 'all',
        active: true,
      }, ...categories]
    })
    fetchCourses(this)
  },
  methods: {
    onChangeMenu: function (id) {
      if (state.categoryCourses[id]) {
        this.courses = state.categoryCourses[id]
      } else {
        fetchCourses(this, id === 'all' ? undefined : id)
      }
      this.categories = this.categories.map((category) => {
        return {
          ...category,
          active: category.id === id,
        }
      })
    },
    onSelectCourse: function (course) {
      Notes.partnerCreateActivity({
        unionId: this.globalData.user.unionId,
        name: this.globalData.mpAccount.name,
        qr: this.globalData.mpAccount.qr,
        classId: course.id,
      }).then(({ channel, classId }) => {
        this.channel = channel
        this.classId = classId
        this.isShareModalActive = true
      })
    },
    close: function () {
      this.isShareModalActive = false
    },
  },
};
</script>

<style src="./index.scss" lang="scss"></style>
